export default __webpack_public_path__ + "static/media/logo_wh34-eu.99810f4c.png";